export const globalMediaStoreTranslations = {
    en: {
        documentTitle: "Document Title",
        documentTitlePlaceholder: "Enter document title",
        documentTitleRequired: "Please enter a document title. It cannot be left blank.",

        description: "Description",
        descriptionRequired: "A short description is required to proceed.",

        fileRequired: "Please upload a file before submitting the form.",
        fileSizeError: "File is too large. Maximum size allowed is 5MB.",
        fileTypeError: "Unsupported file type. Only PDF, Excel, and images are allowed.",

        dragDropOrClick: "Drag & drop a file here, or click to select",
        dropFileHere: "Drop the file here...",
        allowedFileTypes: "(Only PDF, Excel, and image files are allowed)",

        file: "File",
        size: "Size",

        submit: "Submit",
        addSuccess: "Global media gallery document added successfully",
        addError: "Failed to store global media document"
    },
    mr: {
        documentTitle: "दस्तऐवज शीर्षक",
        documentTitlePlaceholder: "दस्तऐवज शीर्षक प्रविष्ट करा",
        documentTitleRequired: "कृपया दस्तऐवज शीर्षक प्रविष्ट करा. ते रिक्त सोडले जाऊ शकत नाही.",

        description: "वर्णन",
        descriptionRequired: "पुढे जाण्यासाठी एक लहान वर्णन आवश्यक आहे.",

        fileRequired: "फॉर्म सबमिट करण्यापूर्वी कृपया फाइल अपलोड करा.",
        fileSizeError: "फाइल खूप मोठी आहे. जास्तीत जास्त 5MB आकार परवानगी आहे.",
        fileTypeError: "असमर्थित फाइल प्रकार. फक्त PDF, Excel आणि प्रतिमांना परवानगी आहे.",

        dragDropOrClick: "येथे फाइल ड्रॅग आणि ड्रॉप करा, किंवा निवडण्यासाठी क्लिक करा",
        dropFileHere: "फाइल येथे ड्रॉप करा...",
        allowedFileTypes: "(फक्त PDF, Excel आणि प्रतिमा फाइल्सना परवानगी आहे)",

        file: "फाइल",
        size: "आकार",

        submit: "सबमिट करा",
        addSuccess: "ग्लोबल मीडिया गॅलरी दस्तऐवज यशस्वीरित्या जोडला",
        addError: "ग्लोबल मीडिया दस्तऐवज संग्रहित करण्यात अयशस्वी"
    }
};
